import {ReloadButton,} from '@flexinet/ui-components';

import {useReconciliationReports} from '../hooks/useReconciliationReports.ts';

export const ReloadRecordsButton = () => {

    const {reload} = useReconciliationReports();
    return (
        <ReloadButton onClick={() => reload()}/>
    );
};
